import React from "react";
import OMap from './../shared/Map';
import Grid from '@material-ui/core/Grid';
import SwipeButton from './SwipeButton';
import HeaderSection from './HeaderSection';
import AttendaceLogs from './AttendaceLogs'
import { connect } from "react-redux";
import jalaliMoment from 'jalali-moment';
import * as registerAttendaceAction from './../../actions/registerAttendace';
import { toast } from 'react-toastify';
import {locationService} from "./../../services/locationService";
import {withRouter} from "react-router-dom";


class RegisterAttendace extends React.Component{
   constructor(props){
       super(props);
       this.state={
           loc:'',
       }
   }
    componentDidMount =  async () => {
        try{
            this.props.loading(true);
            const fromDate = new jalaliMoment();
            fromDate.hour('00');
            fromDate.minutes('00');
            const toDate = new jalaliMoment();
            toDate.hour('23');
            toDate.minutes('59');
            await this.props.getAttendanceLogs(null,fromDate.format("YYYY-MM-DDTHH:mm:ss.SSS Z"),toDate.format("YYYY-MM-DDTHH:mm:ss.SSS Z"))
           
            await this.props.getUserWorkplace();
            const currentLocation = await locationService.getLocation();
            this.setState({loc:currentLocation});
            await this.props.isUserInWorkplace(currentLocation,this.props.registerAttendace.userWorkplaces);
            this.props.loading(false);
        
        }catch(error){
            if(error.response.status===400){
                this.props.history.push("/login")
            }else{
            this.props.loading(false);
            toast.error(error.response.data.Message, {
                position: toast.POSITION.BOTTOM_CENTER
              });
            }

        }
    }
    render = () => {
        return (
            <Grid container className="h-100"  >
                {/* <h1>{this.state.loc}</h1> */}
                <HeaderSection refreshButton={this.componentDidMount}/>
                <OMap />
                <SwipeButton />
                {this.props.registerAttendace.attendaceLogs.length>0 ? <AttendaceLogs /> : '' }
            </Grid>
            
        );
    }
} 
const mapStateToProps = state =>{
    return state
}
export default withRouter(connect(mapStateToProps,registerAttendaceAction)(RegisterAttendace));